import { Component, ElementRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth/auth.service';
import { UserProfileMenuComponent } from '../user-profile-menu/user-profile-menu.component';
import { SidebarService } from '../../services/sidebar/sidebar.service';
import { ScreenService } from '../../services/screen/screen.service';
import { GroupsService } from '../../services/groups/groups.service';
import { CustomDropdownComponent } from '../custom-dropdown/custom-dropdown.component';
import { DropdownItem } from '../../models/filter.model';

import { TEXT_CONSTANTS } from '../../constants/text-constants';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, UserProfileMenuComponent, CustomDropdownComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  TEXT = TEXT_CONSTANTS;

  private _authService = inject(AuthService);
  private _sidebarService = inject(SidebarService);
  private _screenService = inject(ScreenService);
  private _groupsService = inject(GroupsService);

  @ViewChild('dropdownContainer') dropdownContainer?: ElementRef;

  selectedFilter: string | null = 'Personal';
  filterOptions: DropdownItem<string>[] = [];
  notificationsCount = 0;
  isDropdownOpen = false;

  ngOnInit() {
    this._groupsService.selectedGroupId$.subscribe(id => {
      if (!id) this.selectedFilter = TEXT_CONSTANTS.HEADER.FILTERS.PERSONAL;
    });
    this._loadGroupOptions();
  }

  /**
   * Loads group options for the dropdown
   */
  private _loadGroupOptions() {
    this._groupsService.getGroups().subscribe({
      next: (groups) => {
        // Start with "Personal" as the default option
        this.filterOptions = [
          { label: TEXT_CONSTANTS.HEADER.FILTERS.PERSONAL, value: 'personal' }
        ];

        // Add all groups
        groups.forEach(group => {
          this.filterOptions.push({
            label: group.name,
            value: group.id
          });
        });
      },
      error: (error) => {
        console.error('Error loading groups:', error);
        // Fallback to just Personal option
        this.filterOptions = [
          { label: TEXT_CONSTANTS.HEADER.FILTERS.PERSONAL, value: 'personal' }
        ];
      }
    });
  }

  /**
   * Toggles the dropdown open/close state
   */
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  /**
   * Handles filter selection change
   */
  onFilterChange(value: string | null) {
    const selectedOption = this.filterOptions.find(option => option.value === value);
    if (selectedOption) {
      this.selectedFilter = selectedOption.label;
      this._groupsService.setSelectedGroup(value, selectedOption.label);
    }
    this.isDropdownOpen = false;
  }

  /**
   * Close dropdown when clicking outside
   */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.dropdownContainer && !this.dropdownContainer.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  /**
   * Toggles the sidebar menu on mobile.
   */
  toggleMobileMenu() {
    this._sidebarService.toggleSidebar();
  }

  /**
   * Checks if the current view is mobile.
   * @returns True if window width is less than 768px.
   */
  isMobileView(): boolean {
    return this._screenService.isMobile();
  }

  /**
   * Checks if the app is in standalone mode (PWA).
   */
  isStandalone(): boolean {
    return this._screenService.isStandalone();
  }
}

